import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

type Dispute = {
	id: string;
	dealId: string;
	kind: "reconciliation_gap" | "fraud" | "payout_missed" | "contract_breach";
	state: "open" | "evidence" | "review" | "resolved" | "cancelled";
	resolution: string | null;
	createdAt: number;
};

type ListResp = { items: Dispute[]; total: number };

export function Disputes() {
	const { data, isLoading } = useQuery<ListResp>({
		queryKey: ["disputes"],
		queryFn: () => api.get("/disputes"),
	});

	if (isLoading) return <div className="p-6">Loading…</div>;
	const items = data?.items ?? [];

	return (
		<div className="p-6">
			<h1 className="mb-4 text-xl font-semibold">Disputes ({items.length})</h1>
			{items.length === 0 && (
				<div className="text-sm text-neutral-500">
					No disputes. Open one from a deal:{" "}
					<Link to="/deals" className="underline">
						/deals
					</Link>
					.
				</div>
			)}
			<ul className="space-y-2">
				{items.map((d) => (
					<li key={d.id}>
						<Link
							to={`/disputes/${d.id}`}
							className="block rounded border border-neutral-200 p-3 text-sm hover:bg-neutral-50"
						>
							<div className="flex items-center justify-between">
								<div className="font-medium">{d.kind}</div>
								<div className="text-xs text-neutral-500">
									{d.state}
									{d.resolution ? ` (${d.resolution})` : ""}
								</div>
							</div>
							<div className="mt-1 font-mono text-xs text-neutral-500">
								deal {d.dealId.slice(0, 8)}…
							</div>
						</Link>
					</li>
				))}
			</ul>
		</div>
	);
}
